import React, {useState} from "react";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/system";
import CustomerServicesFAQs from "../CustomerServices/CustomerServiceJson.json";
import { Accordion, AccordionDetails, AccordionSummary } from "./CityWiseLoanStyles";

const FAQData = CustomerServicesFAQs?.data[0]?.articles;

const FAQs = () => {
  const [expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (event,newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Container className="faq">
      <Typography className="heading">
        Frequently <br /> asked questions
      </Typography>
      <Container className="faq-container">
        {FAQData?.map((faq) => (
          <Accordion
            expanded={expanded === `${faq?.url_path}`}
            onChange={handleChange(faq?.url_path)}
            key={faq?.topic_id}
          >
            <AccordionSummary aria-controls={faq?.url_path} id={faq?.topic_id} >
              <Typography
                sx={{ fontWeight: expanded == faq?.url_path ? 700 : null }}
              >
                {faq?.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="subtitle2" fontSize={{sm:14,lg:16}}
                dangerouslySetInnerHTML={{
                  __html: faq?.content,
                }}
              />
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Container>
  );
};

export default FAQs;
